import { useSyncExternalStore } from "react";
import { Pressable, ScrollView, View } from "react-native";
import { InsetModal } from "./ui/InsetModal";
import { Text } from "./ui/BrandText";
import { getDialog, resolveDialog, subscribeDialogs } from "../lib/productAlert.web";
import { border, surface, text } from "../theme/tokens";
import { contentMaxWidths } from "../theme/layout";

export function ProductDialogHost() {
  const dialog = useSyncExternalStore(subscribeDialogs, getDialog, () => null);
  if (!dialog) return null;
  return <InsetModal transparent visible animationType="fade" onRequestClose={() => resolveDialog()}>
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 16 }}>
      <View accessibilityViewIsModal accessibilityLabel={dialog.title} style={{ width: "100%", maxWidth: contentMaxWidths.dialog, maxHeight: "100%", backgroundColor: surface.primary, borderRadius: 18, borderWidth: 1, borderColor: border.subtle, padding: 20, gap: 12 }}>
        <Text accessibilityRole="header" style={{ color: text.primary, fontSize: 20, fontWeight: "800" }}>{dialog.title}</Text>
        <ScrollView style={{ flexShrink: 1 }} contentContainerStyle={{ gap: 10 }} keyboardShouldPersistTaps="handled">
          {dialog.message ? <Text style={{ color: text.secondary, lineHeight: 22 }}>{dialog.message}</Text> : null}
          {dialog.buttons.map((button, index) => <Pressable key={index} accessibilityRole="button" onPress={() => resolveDialog(button)} style={({ pressed }) => ({ minHeight: 44, justifyContent: "center", borderRadius: 10, paddingHorizontal: 12, paddingVertical: 10, backgroundColor: button.style === "destructive" ? surface.danger : surface.secondary, opacity: pressed ? 0.7 : 1 })}>
            <Text style={{ color: button.style === "destructive" ? text.danger : text.primary, fontWeight: "700" }}>{button.text ?? "OK"}</Text>
          </Pressable>)}
        </ScrollView>
      </View>
    </View>
  </InsetModal>;
}
